export default __webpack_public_path__ + "static/media/pbi3.cf05aa2b.JPG";